/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelReceivablesHistory.ts            *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/ar/receivables-history";

export class AutogenModelReceivablesHistory<RowType extends ModelRow> extends Endpoint<RowType, RowReceivablesHistoryFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowReceivablesHistory extends ModelRow<RowReceivablesHistoryFields> {
	constructor(values?: Partial<RowReceivablesHistoryFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowReceivablesHistoryFields {
	amount: number;
	amount_c: string;
	amount_d: Date;
	amount_n: number;
	amount_r: number;
	ar_reason_code_id: string;
	bill_date: Date;
	company_from: string;
	company_id: string;
	customer_id: string;
	deposit_number: string;
	gl_date: Date;
	id: string;
	invoice_id: string;
	invoice_no: number;
	invoice_no_string: string;
	is_intercompany: string;
	is_split_bill: string;
	name: string;
	order_id: string;
	original_gl_date: Date;
	original_gl_rate: number;
	post_key: string;
	post_module: string;
	record_type: string;
	reference_number: string;
	remaining_credit_balance: number;
	remaining_credit_balance_c: string;
	remaining_credit_balance_d: Date;
	remaining_credit_balance_n: number;
	remaining_credit_balance_r: number;
	remark: string;
	ship_date: Date;
	source: string;
	company_ids: string;
	include_child_bridge_accounts: boolean;
}

